module.exports = __webpack_public_path__ + "static/media/bursts_10.2ff7b64e.svg";